import { FC } from 'react';
import { Content } from '@prismicio/client';

import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { TableRow, TableWrapper } from '@/components';
import { TableContentVariant } from '@/types';
import { Simplify } from '../../../prismicio-types';

import styles from './californiaPolicyTable.module.scss';

const rowTitleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.rowTitle}>{children}</p>,
};

const headComponents: JSXMapSerializer = {
  paragraph: ({ children }) => (
    <p className={styles.headMobileText}>{children}</p>
  ),
};

type Props = {
  data: Simplify<Content.PolicyTableSliceCaliforniaPolicyPrimary>;
  variant: TableContentVariant;
};

export const CaliforniaBody: FC<Props> = ({ data, variant }) => {
  return (
    <TableWrapper className={styles.body}>
      {data.body.map((item, index) => {
        const hasDescription = 'description' in item;
        const hasCollectedValue = 'collected_value' in item;

        return (
          <TableRow
            key={`${item.title[0]?.type}-${index}`}
            className={styles.row}
          >
            <div className={`${styles.box} ${styles[variant]}`}>
              <PrismicRichText
                field={data.head[0]?.title}
                key={`${item.title[0]?.type}-${index}`}
                components={headComponents}
              />
              <PrismicRichText
                field={item.title}
                components={rowTitleComponents}
              />
            </div>
            <div className={`${styles.box} ${styles[variant]}`}>
              <PrismicRichText
                field={data.head[1]?.title}
                key={`${item.title[1]?.type}-${index}`}
                components={headComponents}
              />
              {hasDescription && (
                <div className={styles.descriptionWrapper}>
                  <PrismicRichText field={item.description} />
                </div>
              )}
            </div>
            <div className={`${styles.box} ${styles[variant]}`}>
              <PrismicRichText
                field={data.head[2]?.title}
                key={`${item.title[2]?.type}-${index}`}
                components={headComponents}
              />
              {hasCollectedValue && (
                <div
                  className={`${styles.collectedValueWrapper} ${variant === 'modal' && styles.modalCollectedValueWrapper}`}
                >
                  <p className={styles.valueWrapper}>
                    <span
                      className={`${styles.value} ${styles[item.collected_value!]}`}
                    >
                      {item.collected_value}
                    </span>
                  </p>

                  {item.collected_value_remark && (
                    <p className={styles.collectedValueRemark}>
                      {item.collected_value_remark}
                    </p>
                  )}
                </div>
              )}
            </div>
          </TableRow>
        );
      })}
    </TableWrapper>
  );
};
